import axios from 'axios';
import { getBackOfficeRoute, headers } from './header';
import { ROLE_ADMIN } from '../../constants/roles';

const MqttApiService = {
  postEvent(token, data) {
    return axios
      .post(`${getBackOfficeRoute(ROLE_ADMIN)}/mqtt/event`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },
};

export default MqttApiService;



// WEBPACK FOOTER //
// ./src/services/api/MqttApiService.js